import { genSubordinateState } from '@web-mail/state/slice/subordinateMailReducer/states';
import { sliceStateCheck } from '@web-mail/utils/slice';
import { LIST_MODEL } from '@web-mail/common/constant';
export const subordinateReducers = {
    doCreateNewSlice_sd(state, action) {
        const { sliceId } = action.payload;
        if (!state.subordinate[sliceId]) {
            state.subordinate[sliceId] = genSubordinateState();
        }
    },
    doRemoveSlice_sd(state, action) {
        const { sliceId } = action.payload;
        if (state.subordinate[sliceId]) {
            delete state.subordinate[sliceId];
        }
    },
    doUpdateSliceAny_sd(state, action) {
        const { sliceId, name, data } = action.payload;
        const isSliceExist = sliceStateCheck(state, sliceId, 'subordinate');
        if (isSliceExist) {
            if (name) {
                try {
                    if (!state.subordinate[sliceId]) {
                        state.subordinate[sliceId] = genSubordinateState();
                    }
                    state.subordinate[sliceId][name] = data;
                }
                catch (e) {
                    console.warn('[subordinate doUpdateSliceAny Error]', name, e);
                }
            }
            else {
                console.warn('[subordinate doUpdateSliceAny Error]', name);
            }
        }
    },
    doUpdateRefreshBtnLoading_sd: (state, action) => {
        const { sliceId, data } = action.payload;
        const isSliceExist = sliceStateCheck(state, sliceId, 'subordinate');
        if (isSliceExist) {
            state.subordinate[sliceId].refreshBtnLoading = data;
        }
    },
    doResetMailSearch_sd: (state, action) => {
        const { sliceId } = action.payload;
        const isSliceExist = sliceStateCheck(state, sliceId, 'subordinate');
        if (isSliceExist) {
            state.subordinate[sliceId].searchLoading = false;
            state.subordinate[sliceId].mailSearchKey = '';
            state.subordinate[sliceId].mailSearchType = 'all';
            state.subordinate[sliceId].mailSearchState = '';
            state.subordinate[sliceId].searchingRequestId = null;
            state.subordinate[sliceId].searchList = [];
            state.subordinate[sliceId].searchTotal = 0;
            state.subordinate[sliceId].activeSearchMailId = '';
            state.subordinate[sliceId].advancedSearchVisible = false;
            state.subordinate[sliceId].advancedSearchLoading = false;
            state.subordinate[sliceId].advanceSearchFromValues = {};
            state.subordinate[sliceId].mailSearchRecord = true;
        }
    },
    doResetMailSearch_sd_more: (state, action) => {
        const { sliceId } = action.payload;
        const isSliceExist = sliceStateCheck(state, sliceId, 'subordinate');
        if (isSliceExist) {
            state.subordinate[sliceId].more_searchInputValue = '';
            state.subordinate[sliceId].more_searchLoading = false;
            state.subordinate[sliceId].mailSearchKey = '';
            state.subordinate[sliceId].mailSearchType = 'all';
            state.subordinate[sliceId].mailSearchState = '';
            state.subordinate[sliceId].more_searchingRequestId = null;
            state.subordinate[sliceId].searchList = [];
            state.subordinate[sliceId].searchTotal = 0;
            state.subordinate[sliceId].activeSearchMailId = '';
            state.subordinate[sliceId].more_advancedSearchVisible = false;
            state.subordinate[sliceId].more_advancedSearchLoading = false;
            state.subordinate[sliceId].more_advanceSearchFromValues = {};
            state.subordinate[sliceId].mailSearchRecord = true;
            state.subordinate[sliceId].defaultMailListSelectedModel = LIST_MODEL.INIT;
            state.subordinate[sliceId].activeIds = [];
        }
    },
};
